import React from 'react';
import { alpha, styled } from '@mui/material/styles';
import {
    Box,
    TextField,
} from '@mui/material';


const ValidationTextField = styled(TextField)({
    '& label': {
        color: 'rgba(178, 235, 177, 1)',
    },
    '& label.Mui-disabled': {
        color: 'rgba(139, 180, 146, 1)',
    },
    '& input.Mui-disabled': {
        borderWidth: 1,
        borderColor: 'rgba(139, 142, 146, 1)',
        backgroundColor: 'rgba(255,255,255, 0.3)',
        borderRadius: 4
    },
    '& label.Mui-focused': {
        color: 'rgba(178, 235, 177, 1)',
    },
    '& input:valid + fieldset': {
        borderWidth: 1,
        borderColor: 'rgba(139, 142, 146, 1)',
    },
    '& input:valid:hover + fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.7)',
        borderWidth: 2
    },
    '& input:valid:focus + fieldset': {
        borderColor: 'rgba(178, 235, 177, 1)',
    },
    '& label.Mui-error': {
        color: 'rgba(255, 105, 97, 1)',  // Light Red for error text
    },
    '& input.Mui-error + fieldset': {
        borderColor: 'rgba(255, 105, 97, 1)', // Strong red border on error
        borderWidth: 2,
    },
  /* Adornment default */
  '& .MuiInputAdornment-root, & .MuiInputAdornment-root .MuiTypography-root': {
    color: 'rgba(178, 235, 177, 0.9)',
    fontWeight: 600,
  },

  /* Adornment focused */
  '& .MuiOutlinedInput-root.Mui-focused .MuiInputAdornment-root, & .MuiOutlinedInput-root.Mui-focused .MuiInputAdornment-root .MuiTypography-root': {
    color: 'rgba(178, 235, 177, 1)',
  },

  /* Adornment error */
  '& .MuiOutlinedInput-root.Mui-error .MuiInputAdornment-root, & .MuiOutlinedInput-root.Mui-error .MuiInputAdornment-root .MuiTypography-root': {
    color: 'rgba(255, 105, 97, 1)',
  },
})


export default function ExpandedTextField(props) {

    const { label, onChange, value, disabled, required=false, error=false, helperText='', inputProps={}} = props

    return (
        <React.Fragment>
            <Box display="flex"
                alignContent="flex-start"
                flexDirection="column"
                flexWrap="wrap"
                width="auto"
                m={1}>
                <Box width="250px">
                    <ValidationTextField
                        label={label} 
                        onChange={(event) => onChange(event, label)}
                        sx={{ input: { color: 'white' } }}
                        variant="outlined"
                        value={value}
                        disabled={disabled || false}
                        required={required}
                        error={error}
                        helperText={helperText}
                        fullWidth
                        InputProps={inputProps}                       
                    />
                </Box>
            </Box>
        </React.Fragment>
    );
}

